import { cx } from '@linaria/atomic';
import { Text } from '../../text';
import * as styles from '../accordion.styles';

type DefaultAccordionHeaderProps = {
  title?: string;
  subtitle?: string;
};

export const DefaultAccordionHeader = ({ title, subtitle }: DefaultAccordionHeaderProps) => {
  return title || subtitle ? (
    <section className={styles.defaultHeaderContainerStyle}>
      {!!title && (
        <Text
          as='span'
          className={cx(styles.defaultHeaderTitleStyle, !!subtitle && styles.defaultHeaderTitleWithSubtitleStyle)}
        >
          {title}
        </Text>
      )}
      {!!subtitle && <Text className={styles.defaultHeaderSubtitleStyle}>{subtitle}</Text>}
    </section>
  ) : null;
};
